import React from "react";
import { MdEmojiEvents } from "react-icons/md";
import { BiaFitUser } from "../../types/user";
import { UserChallenge } from "../../types/challenge";
import { activeChallenges } from "../../utils/challengeAccess";
import { badge, BADGE_PILL } from "../../utils/badgeColors";

// Shared by the desktop table and the mobile card list so they can't drift.

// Whether the account is live or soft-deleted.
export const UserStatusBadge: React.FC<{
  user: Pick<BiaFitUser, "deleted_at">;
}> = ({ user }) => {
  const isDeleted = Boolean(user.deleted_at);
  return (
    <span className={`${BADGE_PILL} ${badge(isDeleted ? "red" : "green")}`}>
      {isDeleted ? "Deleted" : "Active"}
    </span>
  );
};

// One pill per active challenge the user is in; nothing for everyone else.
export const ActiveChallengeBadges: React.FC<{
  user: { challenges?: UserChallenge[] | null };
}> = ({ user }) => {
  const challenges = activeChallenges(user);
  if (challenges.length === 0) {
    return null;
  }

  return (
    <>
      {challenges.map((challenge) => (
        <span
          key={challenge.id}
          className={`${BADGE_PILL} ${badge("pink")}`}
          title={`Active challenge: ${challenge.name}`}
        >
          <MdEmojiEvents className="mr-1 h-3 w-3" />
          {challenge.name}
        </span>
      ))}
    </>
  );
};
